import React, { useContext, useState } from "react";
import { API_URL } from "../components/api";
import { styled, alpha } from "@mui/material/styles";
import AuthContext from "../context/AuthContext";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import Axios from "axios";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": { padding: "4px 0" },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
      "&:hover": { color: "black" },
    },
  },
}));

export default function CustomizedActions(props) {
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [Action, setAction] = useState("");
  const [reason, setReason] = useState("");
  const [openy, setOpeny] = useState(false);
  const [message, setMessage] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleClickOpenpop = () => setOpeny(true);
  const handleClosepop = () => {
    setOpeny(false);
    setReason("");
  };

  const sendAction = (id) => setAction(id);

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const SubmitAction = async () => {
    try {
      await Axios.post(
        `${API_URL}/radius/subscriptions/cable/`,
        {
          Action: "Action",
          result: Action,
          sub_id: props.subscriptions,
          userdealer: user.username,
          reason: reason,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      props.deselect();
      showMessage("Action successful!", "success");
    } catch (error) {
      console.error(error);
      showMessage("Action failed!", "danger");
    }
  };

  return (
    <div className="test">
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        style={{
          backgroundColor: "transparent",
          height: "18px",
          padding: "10px",
        }}
        disableElevation
        onClick={handleClick}
      >
        <i className="fas fa-bolt"></i> Actions
      </Button>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Activate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Activate
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Recharge");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Recharge
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Deactivate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Deactivate
        </MenuItem>
      </StyledMenu>

      <Dialog
        open={openy}
        onClose={handleClosepop}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          {Action === "Deactivate"
            ? "Please provide a reason for deactivation"
            : `Are you sure you want to ${Action}?`}
        </DialogTitle>

        {Action === "Deactivate" && (
          <DialogContent>
            <DialogContentText>
              Enter the reason for deactivation below.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              fullWidth
              variant="standard"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </DialogContent>
        )}

        <DialogActions>
          <Button onClick={handleClosepop}>No</Button>
          <Button
            onClick={() => {
              handleClosepop();
              SubmitAction();
            }}
            autoFocus
            disabled={Action === "Deactivate" && !reason.trim()}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}
